import React from 'react';

interface ErrorMessageProps {
    error: any;
    color?: 'red' | 'blue' | 'green' | 'yellow';
    size?: 'sm' | 'md' | 'lg';
    style?: React.CSSProperties;
}

const sizeMap = { sm: '0.875rem', md: '1rem', lg: '1.125rem' };

const ErrorMessage: React.FC<ErrorMessageProps> = ({
    error,
    color = 'red',
    size = 'sm',
    style = {},
}) => {
    const message = error?.message || error;
    const text = message && typeof message === 'string' ? message : '';

    return (
        <div
            role="alert"
            aria-atomic="true"
            style={text ? { ...style, color, fontSize: sizeMap[size] } : undefined}
        >
            {text}
        </div>
    );
};

export default ErrorMessage;
